module.exports = __webpack_public_path__ + "img/maliciosa.1a20ebe9.jpg";